export default "__VITE_ASSET__HpoPpBMd__"